import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCreditCard = props => (
  <SvgIcon {...props} viewBox="0 0 20 16">
    <path fillRule="evenodd" d="m18 0h-16c-1.11 0-1.99 0.89-1.99 2l-0.01 12c0 1.11 0.89 2 2 2h16c1.11 0 2-0.89 2-2v-12c0-1.11-0.89-2-2-2zm0 14h-16v-6h16v6zm0-10h-16v-2h16v2z" />
  </SvgIcon>
);

export default IconCreditCard;



// WEBPACK FOOTER //
// ./src/components/icons/IconCreditCard.js